export default __webpack_public_path__ + "static/media/yellow-error.61cc43ce.svg";